import { render, staticRenderFns } from "./LayoutUser.vue?vue&type=template&id=2a2788ac&"
import script from "./LayoutUser.vue?vue&type=script&lang=js&"
export * from "./LayoutUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports